/** Browser side effect kept separate so the recovery decision can be tested
 * at the Axios boundary without invoking jsdom's unsupported navigation. */
export function redirectBrowserToLogin(path: string): void {
  if (typeof window !== 'undefined') {
    window.location.href = path;
  }
}
